import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import { valueAccessorFactory } from '../../helpers';
import { BaseInputDirective } from '../base-input.directive';
import { formControlFactory } from '../form-control.provider';
import { CheckboxPosition } from './checkbox-position';
import { CheckboxSize } from './checkbox-size';

@Component({
  selector: 'pcs-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    valueAccessorFactory(CheckboxComponent),
    formControlFactory(CheckboxComponent)
  ]
})
export class CheckboxComponent extends BaseInputDirective implements OnChanges {
  @Input() checked = false;
  @Input() size = CheckboxSize.Default;
  @Input() position = CheckboxPosition.Default;
  @Input() labelSize = 6;
  @Input() set indeterminate(value) {
    this._indeterminate = value;
    this.setIndeterminate();
  }
  @Input()
  @HostBinding('class.form-check-inline') inline = false;

  @Output() selectionChanged = new EventEmitter<boolean>();

  labelClasses = null;

  @ViewChild('checkbox', {static: true}) private checkbox;

  @HostBinding('class.form-check')
  private readonly rootClasses = true;

  get indeterminate() {
    return this._indeterminate;
  }

  private _indeterminate = false;

  @HostBinding('class.small-checkbox')
  private get isSmall() {
    return this.size === CheckboxSize.Small;
  }

  @HostBinding('class.right-checkbox')
  @HostBinding('class.d-flex')
  private get isRight() {
    return this.position === CheckboxPosition.Right;
  }

  @HostBinding('class.mb-half')
  private get editAndSmall() {
    return !this.readonly && this.isSmall;
  }

  @HostBinding('class.mb-0')
  private get readOnlyAndSmall() {
    return this.readonly && this.isSmall;
  }

  constructor(private renderer: Renderer2) {
    super();
  }

  ngOnChanges({labelSize, size, position}: SimpleChanges): void {
    if (labelSize || size || position) {
      this.labelClasses = this.calculateLabelClasses();
    }
  }

  writeValue(value: any): void {
    this.checked = !!value;
    this.setIndeterminate();
  }

  onChange(event) {
    this.checked = event.target.checked;
    this.selectionChanged.emit(this.checked);
    this.propagateChange(this.checked);
  }

  onBlur(event) {
    this.propagateTouched(event);
  }

  private setIndeterminate() {
    if (this.indeterminate && this.checked) {
      this.setIndeterminateProperty(true);
    } else {
      this.setIndeterminateProperty(false);
    }
  }

  private setIndeterminateProperty(indeterminateValue) {
    this.renderer.setProperty(this.checkbox.nativeElement, 'indeterminate', indeterminateValue);
  }

  private calculateLabelClasses() {
    return {
      'col-form-label-sm': this.isSmall,
      [`col-sm-${this.labelSize}`]: this.isRight,
    };
  }
}
